// **************************************** Manufacturing Constants ****************************************

// Manufacturing Dropdown Constants
export const GET_FROM_LOCATION_DROPDOWN_LIST_REQUEST =
  "GET_FROM_LOCATION_DROPDOWN_LIST_REQUEST";
export const GET_FROM_LOCATION_DROPDOWN_LIST_SUCCESS =
  "GET_FROM_LOCATION_DROPDOWN_LIST_SUCCESS";
export const GET_FROM_LOCATION_DROPDOWN_LIST_FAILURE =
  "GET_FROM_LOCATION_DROPDOWN_LIST_FAILURE";

export const GET_TO_LOCATION_DROPDOWN_LIST_REQUEST =
  "GET_TO_LOCATION_DROPDOWN_LIST_REQUEST";
export const GET_TO_LOCATION_DROPDOWN_LIST_SUCCESS =
  "GET_TO_LOCATION_DROPDOWN_LIST_SUCCESS";
export const GET_TO_LOCATION_DROPDOWN_LIST_FAILURE =
  "GET_TO_LOCATION_DROPDOWN_LIST_FAILURE";

export const GET_INVOICE_LIST_REQUEST = "GET_INVOICE_LIST_REQUEST";
export const GET_INVOICE_LIST_SUCCESS = "GET_INVOICE_LIST_SUCCESS";
export const GET_INVOICE_LIST_FAILURE = "GET_INVOICE_LIST_FAILURE";

export const GET_PARTY_LIST_REQUEST = "GET_PARTY_LIST_REQUEST";
export const GET_PARTY_LIST_SUCCESS = "GET_PARTY_LIST_SUCCESS";
export const GET_PARTY_LIST_FAILURE = "GET_PARTY_LIST_FAILURE";

export const GET_SUBLOCATION_LIST_REQUEST = "GET_SUBLOCATION_LIST_REQUEST";
export const GET_SUBLOCATION_LIST_SUCCESS = "GET_SUBLOCATION_LIST_SUCCESS";
export const GET_SUBLOCATION_LIST_FAILURE = "GET_SUBLOCATION_LIST_FAILURE";

// Get Inventory Details
export const GET_INVENTORY_DETAILS_REQUEST = "GET_INVENTORY_DETAILS_REQUEST";
export const GET_INVENTORY_DETAILS_SUCCESS = "GET_INVENTORY_DETAILS_SUCCESS";
export const GET_INVENTORY_DETAILS_FAILURE = "GET_INVENTORY_DETAILS_FAILURE";
export const CLEAR_INVENTORY_DETAILS = "CLEAR_INVENTORY_DETAILS";

// View Previous Boxes
export const VIEW_PREVIOUS_BOX_REQUEST = "VIEW_PREVIOUS_BOX_REQUEST";
export const VIEW_PREVIOUS_BOX_SUCCESS = "VIEW_PREVIOUS_BOX_SUCCESS";
export const VIEW_PREVIOUS_BOX_FAILURE = "VIEW_PREVIOUS_BOX_FAILURE";

// Scan Serial Boxes
export const SCAN_SERIAL_BOX_INVENTORY_REQUEST =
  "SCAN_SERIAL_BOX_INVENTORY_REQUEST";
export const SCAN_SERIAL_BOX_INVENTORY_SUCCESS =
  "SCAN_SERIAL_BOX_INVENTORY_SUCCESS";
export const SCAN_SERIAL_BOX_INVENTORY_FAILURE =
  "SCAN_SERIAL_BOX_INVENTORY_FAILURE";

// Generate MRP LABEL
export const CREATE_MRP_LABEL_REQUEST = "CREATE_MRP_LABEL_REQUEST";
export const CREATE_MRP_LABEL_SUCCESS = "CREATE_MRP_LABEL_SUCCESS";
export const CREATE_MRP_LABEL_FAILURE = "CREATE_MRP_LABEL_FAILURE";

export const CLOSE_BOX_REQUEST = "CLOSE_BOX_REQUEST";
export const CLOSE_BOX_SUCCESS = "CLOSE_BOX_SUCCESS";
export const CLOSE_BOX_FAILURE = "CLOSE_BOX_FAILURE";

export const CREATE_BOX_REQUEST = "CREATE_BOX_REQUEST";
export const CREATE_BOX_SUCCESS = "CREATE_BOX_SUCCESS";
export const CREATE_BOX_FAILURE = "CREATE_BOX_FAILURE";

export const DOWNLOAD_BOX_LABEL_REQUEST = "DOWNLOAD_BOX_LABEL_REQUEST";
export const DOWNLOAD_BOX_LABEL_SUCCESS = "DOWNLOAD_BOX_LABEL_SUCCESS";
export const DOWNLOAD_BOX_LABEL_FAILURE = "DOWNLOAD_BOX_LABEL_FAILURE";

export const GET_SKU_PRODUCTS_REQUEST = "GET_SKU_PRODUCTS_REQUEST";
export const GET_SKU_PRODUCTS_SUCCESS = "GET_SKU_PRODUCTS_SUCCESS";
export const GET_SKU_PRODUCTS_FAILURE = "GET_SKU_PRODUCTS_FAILURE";

export const GET_USER_PROFILE_REQUEST = "GET_USER_PROFILE_REQUEST";
export const GET_USER_PROFILE_SUCCESS = "GET_USER_PROFILE_SUCCESS";
export const GET_USER_PROFILE_FAILURE = "GET_USER_PROFILE_FAILURE";

export const GET_PRODUCTS_LIST_REQUEST = "GET_PRODUCTS_LIST_REQUEST";
export const GET_PRODUCTS_LIST_SUCCESS = "GET_PRODUCTS_LIST_SUCCESS";
export const GET_PRODUCTS_LIST_FAILURE = "GET_PRODUCTS_LIST_FAILURE";

export const SAVE_BOX_TYPE_REQUEST = "SAVE_BOX_TYPE_REQUEST";
export const SAVE_BOX_TYPE_SUCCESS = "SAVE_BOX_TYPE_SUCCESS";
export const SAVE_BOX_TYPE_FAILURE = "SAVE_BOX_TYPE_FAILURE";

export const GET_BOX_TYPE_REQUEST = "GET_BOX_TYPE_REQUEST";
export const GET_BOX_TYPE_SUCCESS = "GET_BOX_TYPE_SUCCESS";
export const GET_BOX_TYPE_FAILURE = "GET_BOX_TYPE_FAILURE";

export const SAVE_BOX_SETTING_REQUEST = "SAVE_BOX_SETTING_REQUEST";
export const SAVE_BOX_SETTING_SUCCESS = "SAVE_BOX_SETTING_SUCCESS";
export const SAVE_BOX_SETTING_FAILURE = "SAVE_BOX_SETTING_FAILURE";

export const GET_BOX_SETTING_REQUEST = "GET_BOX_SETTING_REQUEST";
export const GET_BOX_SETTING_SUCCESS = "GET_BOX_SETTING_SUCCESS";
export const GET_BOX_SETTING_FAILURE = "GET_BOX_SETTING_FAILURE";

export const UNDO_SCANNABLE_INCOMING_REQUEST =
  "UNDO_SCANNABLE_INCOMING_REQUEST";
export const UNDO_SCANNABLE_INCOMING_SUCCESS =
  "UNDO_SCANNABLE_INCOMING_SUCCESS";
export const UNDO_SCANNABLE_INCOMING_FAILURE =
  "UNDO_SCANNABLE_INCOMING_FAILURE";

export const PRODUCT_SUB_GROUP_MASTER_DATA_REQUEST =
  "PRODUCT_SUB_GROUP_MASTER_DATA_REQUEST";
export const PRODUCT_SUB_GROUP_MASTER_DATA_SUCCESS =
  "PRODUCT_SUB_GROUP_MASTER_DATA_SUCCESS";
export const PRODUCT_SUB_GROUP_MASTER_DATA_FAILURE =
  "PRODUCT_SUB_GROUP_MASTER_DATA_FAILURE";

export const GET_BATCHES_REQUEST = "GET_BATCHES_REQUEST";
export const GET_BATCHES_SUCCESS = "GET_BATCHES_SUCCESS";
export const GET_BATCHES_FAILURE = "GET_BATCHES_FAILURE";

export const GET_BATCH_DETAILS_REQUEST = "GET_BATCH_DETAILS_REQUEST";
export const GET_BATCH_DETAILS_SUCCESS = "GET_BATCH_DETAILS_SUCCESS";
export const GET_BATCH_DETAILS_FAILURE = "GET_BATCH_DETAILS_FAILURE";

export const MARK_HOLD_REQUEST = "MARK_HOLD_REQUEST";
export const MARK_HOLD_SUCCESS = "MARK_HOLD_SUCCESS";
export const MARK_HOLD_FAILURE = "MARK_HOLD_FAILURE";

export const PRODUCT_WISE_CONSOLIDATED_REPORT_REQUEST =
  "PRODUCT_WISE_CONSOLIDATED_REPORT_REQUEST";
export const PRODUCT_WISE_CONSOLIDATED_REPORT_SUCCESS =
  "PRODUCT_WISE_CONSOLIDATED_REPORT_SUCCESS";
export const PRODUCT_WISE_CONSOLIDATED_REPORT_FAILURE =
  "PRODUCT_WISE_CONSOLIDATED_REPORT_FAILURE";

export const HOURLY_PRODUCTION__REPORT_REQUEST =
  "HOURLY_PRODUCTION__REPORT_REQUEST";
export const HOURLY_PRODUCTION__REPORT_SUCCESS =
  "HOURLY_PRODUCTION__REPORT_SUCCESS";
export const HOURLY_PRODUCTION__REPORT_FAILURE =
  "HOURLY_PRODUCTION__REPORT_FAILURE";

export const GET_SUB_ORDER_SUMMARY_REQUEST = "GET_SUB_ORDER_SUMMARY_REQUEST";
export const GET_SUB_ORDER_SUMMARY_SUCCESS = "GET_SUB_ORDER_SUMMARY_SUCCESS";
export const GET_SUB_ORDER_SUMMARY_FAILURE = "GET_SUB_ORDER_SUMMARY_FAILURE";

export const SUBORDER_LEVEL_VIEW_CONSOLIDATE_REQUEST =
  "SUBORDER_LEVEL_VIEW_CONSOLIDATE_REQUEST";
export const SUBORDER_LEVEL_VIEW_CONSOLIDATE_SUCCESS =
  "SUBORDER_LEVEL_VIEW_CONSOLIDATE_SUCCESS";
export const SUBORDER_LEVEL_VIEW_CONSOLIDATE_FAILURE =
  "SUBORDER_LEVEL_VIEW_CONSOLIDATE_FAILURE";

export const SAVE_TEMP_HOLD_INVENTORY_REQUEST =
  "SAVE_TEMP_HOLD_INVENTORY_REQUEST";
export const SAVE_TEMP_HOLD_INVENTORY_SUCCESS =
  "SAVE_TEMP_HOLD_INVENTORY_SUCCESS";
export const SAVE_TEMP_HOLD_INVENTORY_FAILURE =
  "SAVE_TEMP_HOLD_INVENTORY_FAILURE";

export const GET_TEMP_HOLD_SUMMARY_REQUEST = "GET_TEMP_HOLD_SUMMARY_REQUEST";
export const GET_TEMP_HOLD_SUMMARY_SUCCESS = "GET_TEMP_HOLD_SUMMARY_SUCCESS";
export const GET_TEMP_HOLD_SUMMARY_FAILURE = "GET_TEMP_HOLD_SUMMARY_FAILURE";

export const DEACTIVATE_HOLD_REQUEST = "DEACTIVATE_HOLD_REQUEST";
export const DEACTIVATE_HOLD_SUCCESS = "DEACTIVATE_HOLD_SUCCESS";
export const DEACTIVATE_HOLD_FAILURE = "DEACTIVATE_HOLD_FAILURE";

export const SALES_ANALYSIS_DETAILS_REQUEST = "SALES_ANALYSIS_DETAILS_REQUEST";
export const SALES_ANALYSIS_DETAILS_SUCCESS = "SALES_ANALYSIS_DETAILS_SUCCESS";
export const SALES_ANALYSIS_DETAILS_FAILURE = "SALES_ANALYSIS_DETAILS_FAILURE";

export const GET_SALES_ANALYSIS_LIST_REQUEST =
  "GET_SALES_ANALYSIS_LIST_REQUEST";
export const GET_SALES_ANALYSIS_LIST_SUCCESS =
  "GET_SALES_ANALYSIS_LIST_SUCCESS";
export const GET_SALES_ANALYSIS_LIST_FAILURE =
  "GET_SALES_ANALYSIS_LIST_FAILURE";

export const GET_PORTAL_NET_INVENTORY_REQUEST =
  "GET_PORTAL_NET_INVENTORY_REQUEST";
export const GET_PORTAL_NET_INVENTORY_SUCCESS =
  "GET_PORTAL_NET_INVENTORY_SUCCESS";
export const GET_PORTAL_NET_INVENTORY_FAILURE =
  "GET_PORTAL_NET_INVENTORY_FAILURE";

export const GET_MISSING_INVENTORY_LIST_REQUEST =
  "GET_MISSING_INVENTORY_LIST_REQUEST";
export const GET_MISSING_INVENTORY_LIST_SUCCESS =
  "GET_MISSING_INVENTORY_LIST_SUCCESS";
export const GET_MISSING_INVENTORY_LIST_FAILURE =
  "GET_MISSING_INVENTORY_LIST_FAILURE";

export const PORTAL_NET_INVENTORY_POPUP_REQUEST =
  "PORTAL_NET_INVENTORY_POPUP_REQUEST";
export const PORTAL_NET_INVENTORY_POPUP_SUCCESS =
  "PORTAL_NET_INVENTORY_POPUP_SUCCESS";
export const PORTAL_NET_INVENTORY_POPUP_FAILURE =
  "PORTAL_NET_INVENTORY_POPUP_FAILURE";

export const SYNC_CRON_FUNCTION_REQUEST = "SYNC_CRON_FUNCTION_REQUEST";
export const SYNC_CRON_FUNCTION_SUCCESS = "SYNC_CRON_FUNCTION_SUCCESS";
export const SYNC_CRON_FUNCTION_FAILURE = "SYNC_CRON_FUNCTION_FAILURE";
